module.exports = {"version":"1.5.0"}


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/cohen.onf.ca/node_modules/poly2tri/dist/version.json
// module id = 669
// module chunks = 0